export default "__VITE_ASSET__0t0mszZQ__"